<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses" id="candidateResume">
    <p class="mb-8 w-32 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdPurple-600 to-bdOrange-600">
      Resume.
    </p>

    <FormButton
      @click="isExpanded = !isExpanded"
      color="outline-blue"
      size="md"
      class="w-full"
      flex
    >
      <span>{{ isExpanded ? 'Collapse' : 'View Resume PDF' }}</span>
      <ChevronDownIcon
        :class="['h-4 w-4 transition-transform', isExpanded ? 'rotate-180' : '']"
      />
    </FormButton>

    <div v-if="isExpanded" class="mt-6">
      <iframe
        :src="candidate.resumes[0].filePath"
        class="w-full h-[600px] border border-slate-200 rounded-lg shadow-sm"
        frameborder="0"
        scrolling="auto"
      />
    </div>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import FormButton from "./FormButton.vue";
import { computed, ref } from "vue";
import { ChevronDownIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
});

const isExpanded = ref(false);

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : " text-base");
});
</script>
